module.exports = __webpack_public_path__ + "static/media/joshcomeau-optimized.16cbb117.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/05-why-gatsby/images/joshcomeau-optimized.jpg
// module id = 963
// module chunks = 0